import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"

import Components from "../components"
import MetaData from "../components/meta-data"
import StructuredData from "../components/structuredMarkup"

const PageLayout = ({ globalData, blok, path }) => (
  <>
    <SbEditable content={blok}>
      {blok.meta_data &&
        blok.meta_data.map((md) => {
          if (md.component === "meta_data")
            return <MetaData key={md._uid} meta_data={md} path={path} />
          if (md.component === "structuredMarkup")
            return <StructuredData key={md._uid} blok={md} />
          return null
        })}
      <>
        {blok.body &&
          blok.body.map((content) =>
            React.createElement(Components(content.component), {
              key: content._uid,
              blok: content,
            })
          )}
      </>
    </SbEditable>
  </>
)

PageLayout.defaultProps = {
  children: [],
}

PageLayout.propTypes = {
  globalData: PropTypes.shape({
    logo: PropTypes.string,
    header_menu: PropTypes.arrayOf(PropTypes.object),
    header_cta: PropTypes.arrayOf(PropTypes.object),
    crumb_trail: PropTypes.arrayOf(PropTypes.object),
    footer: PropTypes.arrayOf(PropTypes.object),
    cookie_notice: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  blok: PropTypes.shape({
    meta_data: PropTypes.arrayOf(
      PropTypes.shape({
        meta_title: PropTypes.string,
        meta_description: PropTypes.string,
        twitter_image: PropTypes.string,
        og_image: PropTypes.string,
        og_video: PropTypes.shape({
          linktype: PropTypes.string,
          cached_url: PropTypes.string,
          url: PropTypes.string,
        }),
        canonical_link: PropTypes.shape({
          linktype: PropTypes.string,
          cached_url: PropTypes.string,
          url: PropTypes.string,
        }),
        no_index: PropTypes.bool,
      })
    ).isRequired,
    header: PropTypes.arrayOf(PropTypes.object),
    body: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  path: PropTypes.string.isRequired,
}

export default PageLayout
